// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Utils = require("../../utils/Utils.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function PseudoJoin(props) {
  let __with_ = props.with_;
  let __as_ = props.as_;
  let as_ = __as_ !== undefined ? __as_ : "span";
  let with_ = __with_ !== undefined ? __with_ : " / ";
  let joined = Utils.$$Array.pseudoJoin(with_, undefined, props.items);
  if (as_ === "p") {
    return JsxRuntime.jsx("p", {
      children: joined
    });
  } else if (as_ === "div") {
    return JsxRuntime.jsx("div", {
      children: joined
    });
  } else {
    return JsxRuntime.jsx("span", {
      children: joined
    });
  }
}

let make = PseudoJoin;

exports.make = make;
/* Utils Not a pure module */
